<div class="aside_title-section">
  <h1 class="title-dashboard">
    {{ 'DEVICE.LOCK.IMMOBILIZER_ACTIVE' | translate }}
  </h1>
</div>
@if (permissionService.checkPermissionValue({ permission: 'READ', tab: 'device' })) {
  <div class="widget-content-height">
    @if ($locked()?.length > 0) {
      @for (device of $locked() | slice: 0 : 5; track device.uid) {
        <device-card [d]="device.uid" [display]="'locked'" />
      }
    } @else {
      <div class="missing-data-dashboard">
        <p>{{ 'DEVICE.LOCK.NO_IMMOBILIZER_BIS' | translate }}</p>
      </div>
    }
  </div>
  @if ($locked()?.length > 5) {
    <div class="data-more-icon">
      <mat-icon (click)="goTo()" [matTooltip]="'COMMON.SEEMORE' | translate">more_horiz</mat-icon>
    </div>
  }
} @else {
  <p class="not-allowed-text">
    {{ 'USER.NOT_ACCESS_DATA' | translate }}
    <br />
    {{ 'USER.PLEASECONTACTADMIN' | translate }}
  </p>
}
